module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./WinningRecordView.js"));
	}, "WinningRecordView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WinningRecordView!./src/pages/Promote/WinningRecord/WinningRecordView.js
// module id = 2118
// module chunks = 367